import CampaignRuleConfig from "@/views/custom/CampaignRuleConfig";

export default {
  key: "campaign",
  id: "id",
  export: ["excel"],
  excel: {
     //max_row: "50000" 
  },
  sort_fields: [
    "id",
    "campaignRuleTypeCode",
    "campaignRuleConfig"
  ],
  filters: {
    // id: {},
    campaignId: {},
    // campaignRuleTypeCode: {
    //   type: "select",
    //   label: "name",
    //   value: "code",
    // },
    // campaignRuleConfig: {}
  },
  fields: [
    { key: "id", width: 40},
    { key: "campaignId", width: "8%"},
    { key: "campaignRuleTypeCode", width: "8%", type: "select", hidden:["list"]},
    {key: "campaignName" , width: "8%"},
    { key: "ruleName", width: "8%", type: "select"},
    { key: "campaignRuleConfig", type: "componentColumn", component: CampaignRuleConfig},
    {key: "description"},
    {key: "descriptionCht"},
    {key: "descriptionChs"},
    { type: "action-btn", width: 100 },
  ],
  structure: [
    ["campaignRuleTypeCode"],
    ["campaignRuleConfig"],
    ["description"],
    ["descriptionCht"],
    ["descriptionChs"],
  ],
  action: ["create","edit","delete"],
  // action: ["create","edit","view","delete"],
  options: {
    campaignRuleTypeCode: {
      key: "campaignRuleTypeCode",
      label: "name",
      value: "code"
    },
  },
  view: [],
  extra_components: {
  },
  disabled_by_column:{
  },
  extra_privillege_components: {
  }
}